export default [
  {
    path: '/admin/v2/purchase-orders',
    name: 'purchase-order-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order-v2')
  },
  {
    path: '/admin/v2/purchase-orders/create',
    name: 'purchase-order-create-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order-v2/create.vue')
  },
  {
    path: '/admin/v2/purchase-orders/:id/edit',
    name: 'purchase-order-edit-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order-v2/edit.vue')
  }
]